/**
 * HTTP layer for a device's configuration document. Reads and patches one relay
 * controller's configuration.
 *
 * Contains:
 * - fetchDeviceConfiguration: read a relay controller's configuration
 * - patchDeviceConfiguration: write a relay controller's configuration
 */
// Unified, schema-driven device configuration. Backed by
// `pliny.odl_app.views.device_configuration.DeviceConfigurationViewSet`.
// PK is the relay controller (SmartLinkUnit) id. GET returns
// `{ relay_controller_id, unit_type, model, schema, values }`; PATCH takes a
// partial, per-section body (`{ network: {...}, device: {...} }`).
import apiClient from '@sophocles/http-common';

const path = relayControllerId => `odl-app/device-configurations/${relayControllerId}/`;

export const fetchDeviceConfiguration = relayControllerId =>
  apiClient.get(path(relayControllerId)).then(res => res.data);

export const patchDeviceConfiguration = (relayControllerId, payload) =>
  apiClient.patch(path(relayControllerId), payload).then(res => res.data);
